import { render, staticRenderFns } from "./ServiceModalList.vue?vue&type=template&id=125dac6e&scoped=true&"
import script from "./ServiceModalList.vue?vue&type=script&lang=js&"
export * from "./ServiceModalList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceModalList.vue?vue&type=style&index=0&id=125dac6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125dac6e",
  null
  
)

export default component.exports